import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack } from '@mui/material';
import { drawerWidth } from 'common/templates/FilterableContent';
import { sidebarStyles } from 'feature/loading-management/utils/const';
import AuthSequencingFilters from './AuthSequencingFilters';

const AuthSequencingFilterContent = ({
  affiliateFilter,
  affiliateOptions,
  locationFilter,
  productFilter,
  setAffiliateFilter,
  setLocationFilter,
  setProductFilter,
  setStatusFilter,
  statusFilter,
}) => {
  return (
    <Box
      sx={{
        ...sidebarStyles,
        border: 0,
        position: 'relative',
        top: 0,
        width: { lg: drawerWidth, xs: 1 },
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        sx={{
          zIndex: { lg: 10 },
        }}
        width={1}
      >
        <Stack
          spacing={3}
          sx={{
            mb: 0,
            p: 3,
            pt: 4,
          }}
        >
          <AuthSequencingFilters
            affiliateFilter={affiliateFilter}
            affiliateOptions={affiliateOptions}
            locationFilter={locationFilter}
            productFilter={productFilter}
            setAffiliateFilter={setAffiliateFilter}
            setLocationFilter={setLocationFilter}
            setProductFilter={setProductFilter}
            setStatusFilter={setStatusFilter}
            statusFilter={statusFilter}
          />
        </Stack>
      </Box>
    </Box>
  );
};

AuthSequencingFilterContent.propTypes = {
  affiliateFilter: PropTypes.shape({}),
  affiliateOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  locationFilter: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  productFilter: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setAffiliateFilter: PropTypes.func.isRequired,
  setLocationFilter: PropTypes.func.isRequired,
  setProductFilter: PropTypes.func.isRequired,
  setStatusFilter: PropTypes.func.isRequired,
  statusFilter: PropTypes.string,
};

AuthSequencingFilterContent.defaultProps = {
  affiliateFilter: null,
  statusFilter: 'All',
};

export default AuthSequencingFilterContent;
